import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import { SubservicesTabs } from "../../components/subservicesTabs/subservicesTabs";

import bgStreamingContent from "../../assets/imgs/servicios/web/apps.jpg";
import bgWebHead from "../../assets/imgs/servicios/web/bg_web_head.png";
import { useTranslation } from "react-i18next";
import { Gallery } from "../../components/gallery/gallery";

import ico01 from "../../assets/imgs/servicios/web/wb01.jpg";
import ico02 from "../../assets/imgs/servicios/web/wb02.jpg";
import ico03 from "../../assets/imgs/servicios/web/wb03.jpg";
import ico04 from "../../assets/imgs/servicios/web/wb04.jpg";
import ico05 from "../../assets/imgs/servicios/web/wb05.jpg";
import ico06 from "../../assets/imgs/servicios/web/wb06.jpg";
export const galleryWeb = [ico01, ico02, ico03, ico04, ico05, ico06];

export const WebDevelopPage = () => {
  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
    };
    scrollToTop();
  });
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>Desarrollo de software - JC Innovation</title>
      </Helmet>
      <section className="wrapper__page_services">
        <div className="contain__head_page">
          <div className="container-lg">
            <div className="row align-items-center">
              <div className="col-md-6">
                <div className="sec_head container_am">
                  <h3 className="ttls ttl_section c_morado mb-4">
                    {t("Desarrollo de software.")}
                  </h3>
                  <p className="paragraph lg">
                    <span className="fw_600 c_primary">
                      {" "}
                      {t("Ingreso fácil y seguro.")}
                    </span>
                  </p>
                  <p className="paragraph lg">
                    {t(
                      "Nuestras plataformas son amigables, intuitivas y creadas para todo tipo de público."
                    )}
                  </p>
                  <p className="paragraph lg">
                    {" "}
                    {t("Somos especialistas en el desarrollo de")}{" "}
                    <span className="c_morado">
                      {t("software funcional y efectivo.")}
                    </span>
                  </p>
                </div>
              </div>
              <div className="col-md-6">
                <div className="text-center">
                  <img src={bgWebHead} alt="Desarrollo web - JC Innovation" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="contain__slide_page">
          <div className="container_am">
            <div className="container_am text-center ">
              <h3 className="ttls ttl_section mb-2">
                <span className="c_morado">
                  {t("El software personalizado")}
                </span>{" "}
                {t("que tu evento se merece.")}
              </h3>
              <p className="paragraph lg">
                {t(
                  "Cubrimos todas las ramas que un proyecto necesita para destacarse de la multitud combinando estrategia, tecnología y creatividad con el objetivo de superar siempre las expectativas de nuestros clientes."
                )}
              </p>
            </div>
          </div>
        </div>

        <div className="contain_info__page ">
          <div className="container-lg">
            <div className="row">
              <div className="col-md-4">
                <div className="col_info">
                  <h3 className="fw_600 mb-4">
                    {t("Creamos plataformas de")}{" "}
                    <span className="c_morado">
                      {t("sistemas de socios, facturación & e-learnings.")}
                    </span>
                  </h3>
                  <p className="paragraph sm">
                    {t(
                      "Generamos comprobantes fiscales automatizados por internet o CFDI de manera rápida y eficaz."
                    )}
                  </p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="con_img_info">
                  <img src={bgStreamingContent} alt="Streaming" />
                </div>
              </div>
              <div className="col-md-4">
                {" "}
                <div className="col_info">
                  <h3 className="fw_600 ">{t("Desarrollo de App nativas.")}</h3>
                  <p className="paragraph sm">
                    {t(
                      "Desarrollamos aplicaciones apegadas a las nuevas tendencias y dirigidas a los principales sistemas operativos como iOS y Android."
                    )}
                  </p>
                  <div>
                    <p className="paragraph sm fw_500 mt-4">
                      <span>
                        <i className="c_primary fa-solid fa-plus"></i>
                      </span>{" "}
                      {t("Registro fácil y rápido.")}
                    </p>
                    <p className="paragraph sm fw_500">
                      <span>
                        <i className="c_primary fa-solid fa-plus"></i>
                      </span>{" "}
                      {t("Login seguro.")}
                    </p>
                    <p className="paragraph sm fw_500">
                      <span>
                        <i className="c_primary fa-solid fa-plus"></i>
                      </span>{" "}
                      {t("Look & feel personalizable.")}
                    </p>
                    <p className="paragraph sm fw_500">
                      <span>
                        <i className="c_primary fa-solid fa-plus"></i>
                      </span>{" "}
                      {t("Reportes y analítica.")}
                    </p>
                    <p className="paragraph sm fw_500">
                      <span>
                        <i className="c_primary fa-solid fa-plus"></i>
                      </span>{" "}
                      {t("Donde quieras y cuando quieras.")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <SubservicesTabs />
        <Gallery images={galleryWeb} title="Desarrollo web" />
      </section>
    </>
  );
};
